import { action, computed, observable } from "mobx";
import CustomerRepository from "../repository/CustomerRepository";
import NestStore from "./NestStore";
import Customer from "../models/Customer";

class CustomerStore extends NestStore {
  /**
   * @property {Customer}
   */
  @observable customer;

  @observable needReload;

  /**
   * @property {Array}
   */
  @observable customers = [];

  /**
   * @private
   */
  #customerCopy;

  /**
   * @property {number}
   */
  @observable customerId;

  customerRepository = null;

  constructor() {
    super();

    this.customer = new Customer({});

    this.customerRepository = new CustomerRepository();
  }

  /**
   * Return if customer has unsaved data or not
   * @returns {boolean}
   */
  @computed
  get hasUnsavedData() {
    return this.customer.isDirty;
  }

  @action
  reset() {
    this.errorMessages = {};
    this.errorMessage = "";
    this.customer = new Customer(this.#customerCopy);
  }

  @action
  load(customerId = null) {
    if (customerId) {
      this.customerId = customerId;
    }

    this.isLoading = true;

    return Promise.all([this.getCustomer()]).then(() => {
      this.isLoading = false;
      this.needReload = false;
    });
  }

  @action
  getCustomer() {
    return this.customerRepository.fetchOne(this.customerId).then(response => {
      this.customer = new Customer(response.data.customer);
    });
  }

  @action
  save = data => this.saveCustomer(this.customerId, data);

  /**
   * @private
   */
  saveCustomer(customerId, data) {
    this.isSaving = true;
    this.errorMessages = {};
    this.errorMessage = "";
    return this.customerRepository
      .update(customerId, data)
      .then(response => {
        if (response.status === "success" && response.data.customer) {
          this.customer = new Customer(response.data.customer);
          this.#customerCopy = response.data.customer;
        }
        this.isSaving = false;
      })
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);

        throw e;
      });
  }

  @action
  loadIndex(params) {
    this.isLoading = true;

    return Promise.all([this.getAll(params)]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll(params) {
    const paramsRequest = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
      ...params,
    };

    return this.customerRepository.fetch(paramsRequest).then(response => {
      this.processEntities(response.data.customers);
      this.processPagination(response.data.pagination);
    });
  }

  @action
  processEntities(customers = []) {
    customers.forEach(customersArray => {
      const customer = new Customer(customersArray);
      this.customers.push(customer);
    });
  }

  @computed
  get actualUser() {
    return this.customer;
  }
}

export default CustomerStore;
